import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useState } from 'react';
import { FLOATING_DEFAULT_WIDTH_PX, FLOATING_MIN_HEIGHT_PX, FLOATING_MIN_WIDTH_PX, INSET_PX, PANEL_HEADER_HEIGHT_PX } from './constants';
// Floating panel position/size/fullscreen state and all drag/resize handling
// (reposition, 3-edge resize, window-resize clamping), isolated from the
// sidebar variant's single-edge resize logic in useSidebarGeometry.
export function useFloatingGeometry(_ref) {
  var startDrag = _ref.startDrag,
    isActive = _ref.isActive;
  var _useState = useState(FLOATING_DEFAULT_WIDTH_PX),
    _useState2 = _slicedToArray(_useState, 2),
    panelWidth = _useState2[0],
    setPanelWidth = _useState2[1];
  var _useState3 = useState(function () {
      return Math.round(window.innerHeight * 0.7);
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    panelHeight = _useState4[0],
    setPanelHeight = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFullscreen = _useState6[0],
    setIsFullscreen = _useState6[1];
  var _useState7 = useState(function () {
      var initialHeight = Math.round(window.innerHeight * 0.7);
      return {
        left: window.innerWidth - FLOATING_DEFAULT_WIDTH_PX - INSET_PX,
        top: window.innerHeight - initialHeight - INSET_PX
      };
    }),
    _useState8 = _slicedToArray(_useState7, 2),
    panelPosition = _useState8[0],
    setPanelPosition = _useState8[1];
  var startPanelDrag = useCallback(function (e) {
    if (e.button !== 0) return;
    if (e.target.closest('button')) return;
    var startX = e.clientX;
    var startY = e.clientY;
    var startLeft = panelPosition.left;
    var startTop = panelPosition.top;
    startDrag(e, function (ev) {
      setPanelPosition({
        left: Math.max(0, Math.min(window.innerWidth - FLOATING_MIN_WIDTH_PX, startLeft + (ev.clientX - startX))),
        top: Math.max(0, Math.min(window.innerHeight - PANEL_HEADER_HEIGHT_PX, startTop + (ev.clientY - startY)))
      });
    });
  }, [panelPosition, startDrag]);
  var startFloatingHeightDrag = useCallback(function (e) {
    var startY = e.clientY;
    var startHeight = panelHeight;
    var bottomEdge = panelPosition.top + startHeight;
    var maxHeight = Math.round(window.innerHeight * 0.9);
    startDrag(e, function (ev) {
      var newHeight = Math.max(FLOATING_MIN_HEIGHT_PX, Math.min(maxHeight, startHeight + (startY - ev.clientY)));
      setPanelHeight(newHeight);
      setPanelPosition(function (pos) {
        return _objectSpread(_objectSpread({}, pos), {}, {
          top: Math.max(0, bottomEdge - newHeight)
        });
      });
    });
  }, [panelHeight, panelPosition, startDrag]);
  var startFloatingWidthDrag = useCallback(function (e) {
    var startX = e.clientX;
    var startWidth = panelWidth;
    var rightEdge = panelPosition.left + startWidth;
    startDrag(e, function (ev) {
      var newWidth = Math.max(FLOATING_MIN_WIDTH_PX, startWidth + (startX - ev.clientX));
      setPanelWidth(newWidth);
      setPanelPosition(function (pos) {
        return _objectSpread(_objectSpread({}, pos), {}, {
          left: Math.max(0, rightEdge - newWidth)
        });
      });
    });
  }, [panelWidth, panelPosition, startDrag]);
  var startFloatingBottomDrag = useCallback(function (e) {
    var startY = e.clientY;
    var startHeight = panelHeight;
    var maxHeight = window.innerHeight - panelPosition.top;
    startDrag(e, function (ev) {
      setPanelHeight(Math.max(FLOATING_MIN_HEIGHT_PX, Math.min(maxHeight, startHeight + (ev.clientY - startY))));
    });
  }, [panelHeight, panelPosition.top, startDrag]);
  var startFloatingRightDrag = useCallback(function (e) {
    var startX = e.clientX;
    var startWidth = panelWidth;
    var maxWidth = window.innerWidth - panelPosition.left;
    startDrag(e, function (ev) {
      setPanelWidth(Math.max(FLOATING_MIN_WIDTH_PX, Math.min(maxWidth, startWidth + (ev.clientX - startX))));
    });
  }, [panelWidth, panelPosition.left, startDrag]);
  useEffect(function () {
    if (!isActive) return;
    function onResize() {
      var maxHeight = Math.round(window.innerHeight * 0.9);
      setPanelHeight(function (h) {
        return Math.min(h, maxHeight);
      });
      setPanelPosition(function (pos) {
        return {
          left: Math.max(0, Math.min(window.innerWidth - FLOATING_MIN_WIDTH_PX, pos.left)),
          top: Math.max(0, Math.min(window.innerHeight - PANEL_HEADER_HEIGHT_PX, pos.top))
        };
      });
    }
    window.addEventListener('resize', onResize);
    return function () {
      return window.removeEventListener('resize', onResize);
    };
  }, [isActive]);
  return {
    panelWidth: panelWidth,
    panelHeight: panelHeight,
    panelPosition: panelPosition,
    isFullscreen: isFullscreen,
    setIsFullscreen: setIsFullscreen,
    startPanelDrag: startPanelDrag,
    startFloatingHeightDrag: startFloatingHeightDrag,
    startFloatingWidthDrag: startFloatingWidthDrag,
    startFloatingBottomDrag: startFloatingBottomDrag,
    startFloatingRightDrag: startFloatingRightDrag
  };
}